import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';

import {
  Box,
  Container,
  Typography,
  CircularProgress,
} from '@material-ui/core';
import { withStyles } from '@material-ui/styles';

import CommonQuestion from '../../components/CommonQuestion';

import FaqStore from '../../stores/FaqStore';

const faqStyles = {
  root: {
    background: '#f3f3f3',
    padding: '64px 0',
    color: '#424242',
    '& a': {
      fontSize: '16px',
      lineHeight: '120%',
      color: '#58c22e',
      '&:hover': {
        color: '#3a9e12',
        textDecoration: 'none',
      },
    },
  },
  boxLoading: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
};

class Faq extends Component {
  async componentDidMount() {
    const { faqStore } = this.props;
    const { getAllFaqs } = faqStore;

    await getAllFaqs();
  }

  render() {
    const { classes, faqStore } = this.props;
    const {
      isLoading,
      data: { faqs },
    } = faqStore;

    return (
      <Box className={classes.root}>
        <Container>
          <Box mb={8}>
            <Typography component="div">
              <Box fontWeight="fontWeightBold" fontSize={21} mb={3}>
                Perguntas frequentes
              </Box>
            </Typography>
            {isLoading ? (
              <Box className={classes.boxLoading}>
                <CircularProgress />
              </Box>
            ) : (
              faqs.map(({ id, question, answer }) => (
                <CommonQuestion key={id} question={question} answer={answer} />
              ))
            )}
          </Box>
          <Box>
            <Typography component="div">
              <Box fontWeight="fontWeightBold" fontSize={21} mb={2}>
                Ainda está com dúvidas?
              </Box>
              <Box fontSize={21} mt={1}>
                Ligue:
                <br />
                <strong>{process.env.REACT_APP_CENTRAL_PHONE_NUMBER}</strong>
              </Box>
            </Typography>
          </Box>
        </Container>
      </Box>
    );
  }
}

Faq.propTypes = {
  classes: PropTypes.object.isRequired,
  faqStore: PropTypes.instanceOf(FaqStore).isRequired,
};

export default withStyles(faqStyles)(inject('faqStore')(observer(Faq)));
